import { render, staticRenderFns } from "./navCatalogueItem.vue?vue&type=template&id=313a7ad6"
import script from "./navCatalogueItem.vue?vue&type=script&lang=js"
export * from "./navCatalogueItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports